'use strict'

import React from 'react';

import Diff from '../components/Diff.jsx';
import FormattedContent from '../components/FormattedContent.jsx';
import {ReportMessage} from '../log/HighlightReport.jsx';

import ReportSection from './ReportSection.jsx';
import formatDate from './formatDate.js';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

function issueDescription(issue,labels) {
  var description=issue!==undefined && issue.description!==undefined && issue.description!==null ? issue.description : "";
  if (issue!==undefined && issue.type!==undefined) {
    description=description.concat("\n");
    description=description.concat("\n"+labels.type+": "+labels.typeValues[issue.type]);
  }
  return description;
}

function issueImpact(issue,labels) {
  var impact=issue.impact!==undefined && issue.impact!==null ? issue.impact : "";
  if (impact!==undefined && issue.severity!==undefined && issue.priority!==undefined) {
    impact=impact.concat("\n");
    impact=impact.concat("\n"+labels.severity+": "+labels.severityValues[issue.severity])
    impact=impact.concat("\n"+labels.priority+": "+labels.priorityValues[issue.priority])
  }
  return impact;
}

function issueDecision(issue,labels) {
  var decision=issue.decision!==undefined && issue.decision!==null ? issue.decision : "";
  if (decision!==undefined && issue.decidedBy!==undefined && issue.deciedBy!==null) {
    decision=decision.concat("\n");
    decision=decision.concat("\n"+labels.decidedBy+" "+issue.decidedBy);
  }
  return decision;
}

function issueStatus(issue,labels) {
  var status=(issue.status==="Closed" ? labels.closed : labels.active);
  if (issue.statusDescription!==undefined && issue.statusDescription!==null) {
    status=status.concat("\n\n").concat(issue.statusDescription);
  }
  return status;
}

export default class IssueDetailsReport extends React.Component {
  render() {
    var date=formatDate(this.props.date,"<not defined>");
    let nameAndDate=(this.props.project!==undefined ? this.props.project.name+" - " : "")+date;
    let labels=translations.getTranslation(this.props).report.issue;
    var style=Object.assign({},{maxWidth:1016},this.props.settings!==undefined ? this.props.settings.style : undefined);
    return (
      <div style={style}>
        <h2 style={{textAlign:"center"}}>
          <div style={{fontSize: "120%"}}>{this.props.exception ? labels.exceptionTitle : labels.title}</div>
          <div>{nameAndDate}</div>
        </h2>
        {this.props.type==="preview" ? <ReportMessage {...this.props} label={labels.previewGenerated}/> : null}
        <div style={{paddingBottom:10}}>
          <h3>{this.props.issue.title}</h3>
          <div>
            <FormattedContent value={issueDescription(this.props.issue,labels)}/>
          </div>
        </div>
        <ReportSection label={labels.impact} value={issueImpact(this.props.issue,labels)}/>
        <ReportSection label={labels.options} value={this.props.issue.options}/>
        <ReportSection label={labels.recommendation} value={this.props.issue.recommendation}/>
        <ReportSection label={labels.decision} optionalIfEmpty={true} value={issueDecision(this.props.issue,labels)}/>
        <ReportSection label={labels.status} optionalIfEmpty={this.props.exception ? true : false} value={issueStatus(this.props.issue,labels)}/>
        {this.props.exception ? (
          <ReportSection label={labels.lessonSummary} value={this.props.issue.lessonSummary}/>
        ) : null}
      </div>
    );
  }
}

class IssueEventDetails extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).report.issue;
    var beforeIssue=this.props.beforeState.issues!==undefined ? this.props.beforeState.issues.filter(issue=>issue.id===this.props.item.id)[0] : undefined;
    var afterIssue=this.props.afterState.issues.filter(issue=>issue.id===this.props.item.id)[0];
    switch (this.props.type) {
      case "capturedIssue":
        return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              <FormattedContent value={issueDescription(afterIssue,labels)}/>
            </div>
          </div>
        );
      case "updatedCapturedIssue":
      return (
        <div>
          <b>{afterIssue.no}. <Diff newValue={afterIssue.title} value={beforeIssue.title}/></b>
          <div>
            <Diff
              value={issueDescription(beforeIssue,labels)}
              newValue={issueDescription(afterIssue,labels)}
            />
          </div>
      </div>
      );
      case "examinedIssue":
        return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              <b>Impact</b>:<br/>
              <FormattedContent value={issueImpact(afterIssue,labels)}/>
            </div>
          </div>
        );
      case "updatedExaminedIssue":
        return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              <b>Impact</b>:<br/>
              <Diff
                value={issueImpact(beforeIssue,labels)}
                newValue={issueImpact(afterIssue,labels)}
              />
            </div>
          </div>
        );
      case "proposedIssue":
      return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              <b>Options</b>:<br/>
              <FormattedContent value={afterIssue.options}/>
            </div>
            <div>
              <b>Recommendation</b>:<br/>
              <FormattedContent value={afterIssue.recommendation}/>
            </div>
            <div>
              <b>Lessons</b>:<br/>
              <FormattedContent value={afterIssue.lessonSummary}/>
            </div>
          </div>
        );
      case "updatedProposedIssue":
      return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              <b>Options</b>:<br/>
              <Diff
                value={beforeIssue.options}
                newValue={afterIssue.options}
              />
            </div>
            <div>
              <b>Recommendation</b>:<br/>
              <Diff
                value={beforeIssue.recommendation}
                newValue={afterIssue.recommendation}
              />
            </div>
            <div>
              <b>Lessons</b>:<br/>
                <Diff
                  value={beforeIssue.lessonSummary}
                  newValue={afterIssue.lessonSummary}
                />
            </div>
          </div>
        );
      case "decidedIssue":
        return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              <b>Decision</b>:<br/>
              <FormattedContent value={issueDecision(afterIssue,labels)}/>
            </div>
          </div>
        );
      case "updatedDecidedIssue":
      return (
        <div>
          <b>{afterIssue.no}. {afterIssue.title}</b>
          <div>
            <b>Decision</b>:<br/>
            <Diff
              value={issueDecision(beforeIssue,labels)}
              newValue={issueDecision(afterIssue,labels)}
            />
          </div>
        </div>
      );
      case "implementedIssue":
        return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              <b>Status</b>:<br/>
              <Diff
                value={issueStatus(beforeIssue,labels)}
                newValue={issueStatus(afterIssue,labels)}
              />
            </div>
          </div>
        );
      case "closedIssue":
      case "reopenedIssue":
        return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              <b>Status</b>:<br/>
              <FormattedContent value={issueStatus(afterIssue,labels)}/>
            </div>
          </div>
        );

      default:
        return (
          <div>
            <b>{afterIssue.no}. {afterIssue.title}</b>
            <div>
              {JSON.stringify(Object.assign({},this.props,{profile:undefined, project:undefined, beforeState:undefined, afterState:undefined}))}
            </div>
          </div>
        );
    }
  }
}

export class IssueDetails extends React.Component {
  render() {
    var issue=this.props.afterState!==undefined && this.props.afterState.issues!==undefined ? this.props.afterState.issues.filter(issue=>issue.id===this.props.item.id)[0] : undefined;
    return (
      <div>
        <IssueEventDetails {...this.props}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/log/IssueDetailsReport.jsx